import React from 'react';
import { Row, Col, Form, Checkbox } from 'antd';

const CheckboxForm = ({ textCheckbox }) => {
  return (
    <Row gutter={[16, 24]}>
      <Col span={24} align="middle">
        <Form.Item name="remember" valuePropName="checked">
          <Checkbox>{textCheckbox}</Checkbox>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default CheckboxForm;
